document.addEventListener(
  'DOMContentLoaded',
  () => {
    const printBtn = document.querySelector('#print-button')
    if (!printBtn) return
    const links = document.querySelector('.terms__links')
    const container = document.querySelector('.terms__wrapper')

    printBtn.addEventListener(
      'click',
      (event) => {
        event.preventDefault()
        links.style.display = 'none'
        window.print()
      },
      false
    )

    container.addEventListener(
      'click',
      () => {
        links.style.display = 'flex'
      },
      false
    )
  },
  false
)
